import { ErrorBoundary as ReactErrorBoundary } from "react-error-boundary"
import { ErrorMessage } from "./ErrorMessage"
import { appInsights } from "../../logging/ApplicationInsightsService"
import { BASE_ROUTE } from "../../../routes"

function fallbackRender({
  resetErrorBoundary,
}: {
  resetErrorBoundary: () => void
}) {
  return (
    <main>
      <ErrorMessage
        clickHandlerOverride={resetErrorBoundary}
        sessionIdMessage={`SESSION ID: ${appInsights.context.sessionManager.automaticSession.id}`}
      />
    </main>
  )
}

export const ErrorBoundary = ({ children }: { children: React.ReactNode }) => {
  return (
    <ReactErrorBoundary
      FallbackComponent={fallbackRender}
      onReset={() => {
        window.location.href = BASE_ROUTE
      }}
      resetKeys={[children]}
    >
      {children}
    </ReactErrorBoundary>
  )
}
